/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import HeroBanner from '../components/Feature/Banner/HeroBanner';
import PageBanner from '../components/Feature/Banner/PageBanner';
import SmallPageBanner from '../components/Feature/Banner/SmallPageBanner';
import FAQ from '../components/Feature/Cards/FAQ';
import ImageAndContentCards from '../components/Feature/Cards/ImageAndContentCards';
import Insights from '../components/Feature/Cards/Insights';
import LinksCards from '../components/Feature/Cards/LinksCards';
import Maps from '../components/Feature/Cards/Maps';
import ProfileCards from '../components/Feature/Cards/ProfileCards';
import TwoCards from '../components/Feature/Cards/TwoCards';
import LogoCarousel from '../components/Feature/Carousel/LogoCarousel';
import TabbedCarousel from '../components/Feature/Carousel/TabbedCarousel';
import TimelineCarousel from '../components/Feature/Carousel/TimelineCarousel';
import CardWithBackgroundTheme from '../components/Feature/ContentBlock/CardWithBackgroundTheme';
import ErrorBlock from '../components/Feature/ContentBlock/ErrorBlock';
import PageBody from '../components/Feature/ContentBlock/PageBody';
import PartnerList from '../components/Feature/ContentBlock/PartnerList';
import Quote from '../components/Feature/ContentBlock/Quote';
import ShadowImageAndContentBlock from '../components/Feature/ContentBlock/ShadowImageAndContentBlock';
import TextWithBackgroundColor from '../components/Feature/ContentBlock/TextWithBackgroundColor';
import TitleAndDescription from '../components/Feature/ContentBlock/TitleAndDescription';
import Elements from '../components/Feature/Elements/Elements';
import Forms from '../components/Feature/Forms/Forms';
import LatestNews from '../components/Feature/GQL/LatestNews';
import MediaListing from '../components/Feature/GQL/MediaListing';
import SearchResults from '../components/Feature/GQL/SearchResults';
import DetailsDescription from '../components/Feature/Media/DetailsDescription';
import MediaDetailsBody from '../components/Feature/Media/MediaDetailsBody';
import Video from '../components/Feature/Media/Video';
import Footer from '../components/Feature/Navigation/Footer';
import Header from '../components/Feature/Navigation/Header';

const components = new Map();
components.set('HeroBanner', HeroBanner);
components.set('PageBanner', PageBanner);
components.set('SmallPageBanner', SmallPageBanner);
components.set('FAQ', FAQ);
components.set('ImageAndContentCards', ImageAndContentCards);
components.set('Insights', Insights);
components.set('LinksCards', LinksCards);
components.set('Maps', Maps);
components.set('ProfileCards', ProfileCards);
components.set('TwoCards', TwoCards);
components.set('LogoCarousel', LogoCarousel);
components.set('TabbedCarousel', TabbedCarousel);
components.set('TimelineCarousel', TimelineCarousel);
components.set('CardWithBackgroundTheme', CardWithBackgroundTheme);
components.set('ErrorBlock', ErrorBlock);
components.set('PageBody', PageBody);
components.set('PartnerList', PartnerList);
components.set('Quote', Quote);
components.set('ShadowImageAndContentBlock', ShadowImageAndContentBlock);
components.set('TextWithBackgroundColor', TextWithBackgroundColor);
components.set('TitleAndDescription', TitleAndDescription);
components.set('Elements', Elements);
components.set('Forms', Forms);
components.set('LatestNews', LatestNews);
components.set('MediaListing', MediaListing);
components.set('SearchResults', SearchResults);
components.set('DetailsDescription', DetailsDescription);
components.set('MediaDetailsBody', MediaDetailsBody);
components.set('Video', Video);
components.set('Footer', Footer);
components.set('Header', Header);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
